import peBeluga from './initial/peBeluga';
import peBelugaMonthly from './monthly/peBelugaMonthly';
import pe from './initial/pe';
import peFollowup from './followup/peFollowup';

const PEQuestions = [...peBelugaMonthly, ...peBeluga, ...pe, ...peFollowup];

export default PEQuestions;
